<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goback">返回</el-button>

    <el-tabs type="border-card" v-model="activeName" style="margin-top: 20px;">
      <!-- 按签到 -->
      <el-tab-pane label="按签到统计" name="StatisticsBySignMsg">
        <sign-msg-list :live-i-d="liveID"/>
      </el-tab-pane>
      <!--按用户-->
      <el-tab-pane label="按用户统计" name="StatisticsByUser">
        <user-list :live-i-d="liveID"/>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import SignMsgList from "@/views/systemManagement/liveMgt/liveList/SignMsg/SignMsgList";
import UserList from "@/views/systemManagement/liveMgt/liveList/SignMsg/SignByUserList";
import {isVaild} from "@/utils/validate";

export default {
  name: "index",
  components: {UserList, SignMsgList},
  data() {
    return {
      liveID: 0,
      activeName: "StatisticsBySignMsg",
    }
  },
  created() {
    let queryID = this.$route.query.liveID
    if (isVaild(queryID)) {
      this.liveID = Number(queryID)
    }
  },
  methods: {
    goback() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>